module.exports = new Proxy(
  {},
  {
    get(_, prop) {
      return prop
    },
  }
)
